import React, { useCallback } from 'react';

// DEPENDENCIES
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

// GLOBAL VARIABLES
import { BUTTON } from 'defaults.js';
import { INTERFACE, RECORD } from 'pathnames.js';

// GLOBAL FUNCTIONS
import { formatDate, formatTime, makePath, parseLink } from 'functions';

// LOCAL VARIABLES
import { INVENTORY_DATA_LABELS } from '../variables';

// BOOTSTRAP COMPONENTS
import { Col, Row } from 'react-bootstrap';

// CORE COMPONENTS
import Form from 'core/form/Form';
import Button from 'core/tools/Button';

// GLOBAL PARTS
import Sidebar from 'parts/sidebar/Sidebar';

// STYLES
import styles from './vehicleInfoSidebar.module.scss';

// MAIN COMPONENT
const VehicleInfoSidebar = () => {

  // PROPS
  const { inventory: { warning_message, ...inventory } = {}, sales = [] } = useSelector(({ sidebar }) => sidebar.vehicleInfo) || {};

  // REAXT ROUTER
  const navigate = useNavigate();

  // CALLBACKS
  const handleClick = useCallback(
    () => {
      navigate(makePath(INTERFACE.sales, RECORD.add, inventory.daily_sales_inventory_id))
    },
    [inventory.daily_sales_inventory_id, navigate]
  )

  return (
    <Sidebar
      name="vehicleInfo"
      title="Vehicle Info"
      size="lg"
    >
      <Sidebar.Form
        buttons={{
          show: !warning_message,
          submit: {
            type: 'button',
            variant: 'primary',
            label: BUTTON.add.label,
            icon: BUTTON.add.icon,
            onClick: handleClick
          }
        }}
        vertical={false}
      >
        {!!warning_message && (
          <Form.Col>
            <h5 className={styles.warning}>{parseLink(warning_message, 'sales_id', makePath(INTERFACE.sales, RECORD.view))}</h5>
          </Form.Col>
        )}
        {Object.keys(INVENTORY_DATA_LABELS).map((key, i) => (
          <Form.PlainText
            key={i}
            label={INVENTORY_DATA_LABELS[key]}
            value={inventory[key]}
          />
        ))}
        {!!sales.length &&
          <Form.Col>
            <div className={styles.salesTable}>
              <div className={styles.header}>
                <Row>
                  <Col>Time</Col>
                  <Col>Status</Col>
                  <Col>Customer</Col>
                  <Col>Sales Person</Col>
                  <Col className={styles.buttonCol}></Col>
                </Row>
              </div>
              <div className={styles.body}>
                {sales.map(({ customer_name, sales_id, sales_person, sales_time, status }) => (
                  <Row>
                    <Col>{formatDate(sales_time)}<br />{formatTime(sales_time)}</Col>
                    <Col className={['Fallout', 'Backout'].includes(status) && 'text-danger'}>{status}</Col>
                    <Col>{customer_name}</Col>
                    <Col>{sales_person}</Col>
                    <Col className={styles.buttonCol}>
                      <Button.Link
                        to={makePath(INTERFACE.sales, RECORD.view, sales_id)}
                        icon={{ use: 'folder', hover: 'folder-open' }}
                      />
                    </Col>
                  </Row>
                ))}
              </div>
            </div>
          </Form.Col>
        }
      </Sidebar.Form>
    </Sidebar>
  )
}

// EXPORT
export default VehicleInfoSidebar;
